/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState, useRef } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { useSpring, animated, config, Transition } from 'react-spring'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { TypescriptComponent } from 'components/typescriptExample'
import { Link } from '@ta-interaktiv/contentbricks'
import { Scrollchor } from 'react-scrollchor'
import { Element, scroller } from 'react-scroll'

const ARTICLE_ID = '249093797114'

export function AppComponent() {
  const [selectedSuite, setSelectedSuite] = useState(false)

  const [mainStylesB, mainStylesBapi] = useSpring(() => ({
    scale: 1,
    opacity: 1,
    config: config.slow
  }))

  const [mainStylesC, mainStylesCapi] = useSpring(() => ({
    opacity: 1,
    config: config.slow
  }))

  const handleScroll = () => {
    mainStylesBapi.start({
      opacity: 1 - window.scrollY / 1000,
      scale: window.scrollY / 200 < 1 ? 1 : window.scrollY / 200
    })
    mainStylesCapi.start({
      opacity: 1 - window.scrollY / 500
    })
  }

  useEffect(() => {
    selectedSuite &&
      scroller.scrollTo('rooms-container', {
        duration: 1500,
        delay: 100,
        smooth: true
      })
  }, [selectedSuite])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const [showImage, setShowImage] = useState(false)

  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <div className='image-wrapper'>
        <figure className='image-container'>
          <animated.img
            style={mainStylesB}
            src={require('../../images/entree.jpg')}
          />
          <animated.div style={mainStylesC} className='text-gradient' />
        </figure>
      </div>

      <header className='ui vertical  very fitted  segment'>
        <div className='ui text container'>
          <div className='ui header inverted'>
            <h1>
              Voici la suite à plus de 50'000 francs où pourrait loger Joe Biden
            </h1>
            <h2>
              L'Hôtel Intercontinental de Genève devrait être un lieu clé du
              sommet entre Joe Biden et Vladimir Poutine. Plongez-vous dans le
              luxe de ce palace.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Julien Culet</div>
            <div className='ta updated'>Mis à jour le 3 juin 2021</div>
          </div>
          <div className='ta text'>
            <p>
              Les 15 et 16 juin prochains, les présidents américains et russes
              se rencontreront à Genève pour un{' '}
              <Link href='674595297741'>sommet historique</Link>. Pour des
              questions d’organisation et de sécurité, les lieux dans lesquels
              se tiendront l’événement ne sont pas encore confirmés
              officiellement mais l’Hôtel Intercontinental devrait jouer un rôle
              clé. Selon nos informations, les chefs des services de sécurité
              des deux chefs d’Etat s’y sont rencontrés récemment et il
              semblerait que Joe Biden prendra ses quartiers dans le palace. Ce
              dernier est également sur les rangs pour accueillir le point
              d’orgue du sommet: la rencontre du 46e président des Etats-Unis
              avec Vladimir Poutine.
            </p>
            <p>
              Cette rencontre s'inscrit dans une histoire riche en événements
              diplomatiques pour l'Intercontinental. Une place sur la scène
              internationale que l'hôtel doit à sa situation géographique. À
              cinq minutes de route de l'aéroport de Cointrin, en plein cœur des
              organisations internationales, son emplacement est idéal pour
              accueillir des chefs d'Etat. Il est également{' '}
              <Link href='629255514977'>plus facile à sécuriser</Link> qu'un
              établissement du centre-ville.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui ta text container'>
          <figure className='ui raised segment map'>
            <img src={require('../../images/carte.svg')} />
            {/* <AutofitIFrame
              aria-label='TODO: set label'
              src='https://datawrapper.dwcdn.net/AVTI4'
            /> */}
          </figure>
          <figcaption>Infographie: I. Caudullo</figcaption>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              En prévision de l’événement, nous avons pu visiter{' '}
              <b>les suites les plus luxueuses</b> de l’établissement. Découvrez
              les lieux dans lesquels les plus grands chefs d’Etat et nombre de
              célébrités de tous horizons ont séjourné depuis l’inauguration en
              1964.
            </p>
            {/* <blockquote cite='http://www.worldwildlife.org/who/index.html'>
              <p>
                Donec pede justo, fringilla vel, aliquet nec, vulputate eget,
                arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae,
                justo.
              </p>
              <span>Donec Pado, justo fringilla vel</span>
            </blockquote> */}
          </div>
        </div>
      </div>

      {/* <Transition
        items={selectedSuite}
        reverse={selectedSuite}
        from={{ opacity: 1, translateY: -110 }}
        enter={{ opacity: 1, translateY: -10 }}
        leave={{ opacity: 1, translateY: -110 }}
        delay={200}
        config={{ ...config.slow, friction: 20 }}
      >
        {(styles, item) =>
          item && (
            <animated.div style={styles} className='menu-bar'>
              menu
            </animated.div>
          )
        }
      </Transition> */}

      <div id='menu' className='ui vertical segment menu'>
        <div className='ui container'>
          <div className='ui stackable two column grid'>
            <div className='column'>
              <div
                className='ui raised segment'
                onClick={() => {
                  setSelectedSuite(2)
                }}
              >
                <h3>Suite présidentielle</h3>

                <h4>
                  <span>5'000</span> CHF/nuit
                </h4>
                <div className='menu-desc'>
                  Les cinq suites présidentielles servent de logement aux
                  ministres lors des grands sommets internationaux.
                </div>
                <div className='menu-infos'>
                  <div>
                    <b>Superficie</b>: 120m2
                  </div>
                  <div>
                    <b>Prestations</b>: deux pièces à vivre, bureau panoramique,
                    grand dressing, baignoire en marbre, douche italienne
                  </div>
                </div>
                <img src={require('../../images/door_b.svg')} />
                <div className='bt-back'>
                  <div className='bt'>
                    Visiter la suite <i className='ui icon chevron right' />
                  </div>
                </div>
              </div>
            </div>
            <div className='column suite-b'>
              <div
                className='ui raised segment'
                onClick={() => {
                  setSelectedSuite(1)
                }}
              >
                <h3>La Résidence</h3>
                <h4>
                  <span>50'000</span> CHF/nuit
                </h4>
                <div className='menu-desc'>
                  La suite la plus chère de l’Hôtel Intercontinental. C’est ici
                  que devrait séjourner le président américain Joe Biden.
                </div>
                <div className='menu-infos'>
                  <div>
                    <b>Superficie</b>: 650m2
                  </div>
                  <div>
                    <b>Prestations</b>: 2 chambres de maître, 1 grand salon avec
                    cheminée, 2 cuisines entièrement équipées, 1 bar, 2 salles à
                    manger, 2 cabinets de toilette, 2 dressings, 2 hammams, 1
                    sauna, 1 salle de remise en forme, 1 salle de massage
                  </div>
                </div>
                <img src={require('../../images/door_a.svg')} />
                <div className='bt-back'>
                  <div className='bt'>
                    Visiter la suite <i className='ui icon chevron right' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedSuite && (
        <Element name='rooms-container'>
          {selectedSuite === 1 && (
            <div>
              <div className='ui vertical grey segment'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h4>La Résidence</h4>
                    <p>
                      Il s’agit de la suite la plus chère de l’Hôtel
                      Intercontinental puisqu’il faut débourser plus de 50000
                      francs pour y loger pendant une nuit. C’est ici que
                      devrait séjourner le président américain Joe Biden. Située
                      au 18e étage et jouissant d’un panorama sur tout le bout
                      du lac et sur les montagnes, La Résidence est “la plus
                      haute et la plus grande suite de Genève”, vante l’hôtel.
                      Avec une superficie de 450m2 et ses très nombreux miroirs,
                      on pourrait facilement s’y perdre.
                    </p>
                    <p>
                      La quasi-totalité des équipements sont présents en double
                      car il est possible de séparer la Résidence impériale en
                      deux suites. Elle occupe également la moitié de l’étage,
                      celui-ci étant occupé par d’autres chambres plus
                      classiques. Elles peuvent alors être destinées au
                      personnel accompagnant les riches locataires des lieux.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container'>
                    <h3 className='special'>1.</h3>
                    <h4 className='special'>Les portes</h4>
                    <p>
                      Il faut donc prendre l’ascenseur jusqu’au dernier étage
                      pour se rendre à La Résidence. Pour garantir la sécurité
                      des hôtes de marque qui y logent, le niveau est accessible
                      uniquement avec la clé de la luxueuse suite. On se
                      retrouve alors nez à nez avec d’imposantes portes bleues
                      qui se veulent être “aussi hautes que celles du château de
                      Versailles”. C’est en les poussant que l’on arrive dans le
                      hall de ce grand appartement.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={21}
                        imgSrc={require('../../images/entree.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container'>
                    <h3 className='special'>2.</h3>
                    <h4 className='special'>Le salon</h4>
                    <p>
                      L’entrée débouche sur un vaste espace à vivre. Un grand
                      salon l’occupe aux deux tiers. Le reste est pris par un
                      bar. Une grande baie vitrée permet d’observer une vue
                      imprenable sur Genève. Si l’hôtel a comme particularité de
                      ne pas être situé dans au bord du lac, la hauteur de la
                      suite permet malgré tout de profiter d’un somptueux
                      panorama.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={1}
                        imgSrc={require('../../images/suite_1.jpg')}
                      />
                      <TypescriptComponent
                        type={2}
                        imgSrc={require('../../images/suite_3.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container center aligned'>
                    <h3 className='special'>3.</h3>
                    <h4 className='special'>Oeuvres d'art</h4>
                    <p>
                      La Résidence est décorée d’une multitude d'œuvres d’art.
                      Sa conception a été assurée par l’architecte new-yorkais
                      Tony Chi. A l’image des portes inspirées de Versailles, la
                      philosophie qui a guidé la création de la suite était
                      “l’élégance majestueuse des palais opulents du passé”.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={1}
                        imgSrc={require('../../images/suite_4.jpg')}
                      />
                      <TypescriptComponent
                        type={2}
                        imgSrc={require('../../images/suite_12.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container center aligned'>
                    <h3 className='special'>4.</h3>
                    <h4>Les salles de bain</h4>
                    <p>
                      Les salles de bain jouissent d’un luxe sans pareil. Les
                      deux grandes baignoires circulaires ont été taillées dans
                      le même bloc de marbre. L’une des deux salles d’eau donne
                      sur une salle de massage dans laquelle l’occupant peut se
                      relaxer. La suite comporte également un hammam.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery type-2'>
                      <TypescriptComponent
                        type={5}
                        imgSrc={require('../../images/suite_7.jpg')}
                      />
                      <TypescriptComponent
                        type={3}
                        imgSrc={require('../../images/suite_6.jpg')}
                      />
                      <TypescriptComponent
                        type={4}
                        imgSrc={require('../../images/suite_5.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container center aligned'>
                    <h3 className='special'>5.</h3>
                    <h4>Les chambres</h4>
                    <p>
                      Les deux chambres sont équipées d’un lit king size qui
                      paraîtrait presque petit et assez sobre par rapport au
                      reste des lieux. Une grande télévision à écran plat et un
                      vaste miroir sont également présents.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery type-2'>
                      <TypescriptComponent
                        type={5}
                        imgSrc={require('../../images/suite_8.jpg')}
                      />
                      <TypescriptComponent
                        type={3}
                        imgSrc={require('../../images/suite_9.jpg')}
                      />
                      <TypescriptComponent
                        type={4}
                        imgSrc={require('../../images/suite_10.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='room'>
                <div className='ui vertical segment'>
                  <div className='ui ta text container center aligned'>
                    <h3 className='special'>6.</h3>
                    <h4>La salle de sport</h4>
                    <p>
                      Si un côté de la suite a une salle de massage pour le
                      réconfort, l’autre côté comporte pour sa part une salle de
                      remise en forme. Un tapis de course, un vélo d’appartement
                      ainsi qu’un banc de musculation et ses nombreuses haltères
                      permettent de se défouler entre deux visites ou rencontres
                      internationales. Le tout avec la vue sur le bout du lac,
                      bien entendu.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={21}
                        imgSrc={require('../../images/suite_11.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {selectedSuite === 2 && (
            <div>
              <div className='ui vertical grey segment'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h4>Suites présidentielles</h4>
                    <p>
                      Aux 16e et 17e étages de l’hôtel, les cinq suites
                      présidentielles servent de logement aux ministres lors des
                      grands sommets internationaux, explique l’ancien directeur
                      Herbert Schott. C’est également là que séjournent
                      généralement les personnalités d’importance. Mikhaïl
                      Gorbatchev était basé à la mission soviétique lors de sa
                      rencontre historique avec Ronald Reagan en 1985 mais il a
                      été séduit par son passage à l’Intercontinental et a
                      plusieurs fois séjourné dans une des suites
                      présidentielles du palace, après la chute de l’URSS.
                    </p>
                    <p>
                      D’une superficie de 120m2, les suites présidentielles
                      apparaissent bien modestes par rapport à La Résidence et
                      ne présentent pas le même style. S’il a un côté ancien,
                      très hôtel des années 1970, il se veut sobre, à l’image de
                      la rénovation de l’établissement, effectuée en 2008. Un
                      classicisme dû à une volonté de faire de ces suites une
                      “célébration contemporaine du luxe et du patrimoine
                      d’antan”. L’idée, pour l’hôtel, était de garder un style
                      épuré, sans artifice, qui met en évidence des matériaux
                      nobles comme le bois. Le but est d’avoir une décoration
                      sobre, chic et élégante qui puisse convenir au plus grand
                      nombre pour se sentir bien lors d’un séjour dans le
                      palace.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container'>
                    <h3 className='special'>1.</h3>
                    <h4 className='special'>Salon</h4>
                    <p>
                      L’entrée dans une de ces suites marque le visiteur par la
                      faible hauteur de plafond dans le hall. Un vaste dressing
                      permet de laisser ses affaires avant de déboucher dans une
                      grande pièce à vivre. Elle est composée d’un espace salon,
                      avec fauteuils et canapé, et d’une grande table à manger
                      ou de réunion. La suite visitée comportait aussi de
                      nombreux livres dont plusieurs sur la Russie, comme les
                      mémoires de l’ancien dirigeant de l’URSS Nikita
                      Khrouchtchev. De quoi permettre à un ministre américain de
                      potasser sur l’histoire du grand pays rival. Un autre plus
                      petit salon est également présent dans la suite.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={21}
                        imgSrc={require('../../images/suite_21.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container'>
                    <h3 className='special'>2.</h3>
                    <h4 className='special'>Chambre</h4>
                    <p>
                      La chambre est peut-être la pièce la moins tape-à-l’oeil
                      de la suite. Elle est relativement classique voire un peu
                      sombre avec son bois et son capitonnage sombre. Le confort
                      est toutefois bien au rendez-vous avec un lit king-size.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={1}
                        imgSrc={require('../../images/suite_23.jpg')}
                      />
                      <TypescriptComponent
                        type={2}
                        imgSrc={require('../../images/suite_22.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container center aligned'>
                    <h3 className='special'>3.</h3>
                    <h4 className='special'>Salle de bain</h4>
                    <p>
                      Toujours dans un but de mettre en valeur des matériaux
                      nobles, la salle de bain est décorée tout en marbre. Le
                      sol, les murs, les lavabos mais surtout la grande
                      baignoire sont faits en cette roche. Une baignoire qui est
                      idéalement située devant une fenêtre pour pouvoir se
                      prélasser tout en ayant une vue imprenable sur le jet
                      d’eau.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={1}
                        imgSrc={require('../../images/suite_24.jpg')}
                      />
                      <TypescriptComponent
                        type={2}
                        imgSrc={require('../../images/suite_25.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className='room'
                style={{
                  backgroundImage:
                    'url(' + require('../../images/border.svg') + ')'
                }}
              >
                <div className='ui vertical segment'>
                  <div className='ui ta text container center aligned'>
                    <h3 className='special'>4.</h3>
                    <h4>Autres pièces</h4>
                    <p>
                      Enfin, à noter que les suites présidentielles sont toutes
                      modulables. Des portes sont en effet présentes à
                      l’intérieur pour accéder à d’autres chambres plus
                      classiques. Il est donc possible d’en louer trois ou
                      quatre pour privatiser une partie de l’étage et
                      communiquer ainsi entre les occupants. Tout est possible,
                      précise l’hôtel.
                    </p>
                  </div>
                </div>

                <div className='ui vertical segment'>
                  <div className='ui container'>
                    <div className='gallery'>
                      <TypescriptComponent
                        type={21}
                        imgSrc={require('../../images/suite_26.jpg')}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Element>
      )}

      {selectedSuite && (
        <div className='ui vertical segment'>
          <div className='ui container center aligned'>
            {' '}
            <div className='bt-back'>
              <Scrollchor to='#menu'>
                <div className='bt'>
                  Visiter une autre suite{' '}
                  <i className='ui icon chevron right' />
                </div>
              </Scrollchor>
            </div>
          </div>
        </div>
      )}

      <div
        className='ui vertical segment goto'
        style={{ backgroundColor: selectedSuite ? '#2ca29f' : '#217977' }}
      >
        <div className='ui text container'>
          <div className='teaser ui raised segment'>
            <Link href='358447469954'>
              <img src={require('../../images/teaser.jpg')} />
              <div>
                <div className='teaser-title'>
                  L’Hôtel Intercontinental joue les diplomates depuis 67 ans
                </div>{' '}
                <div>
                  Le palace genevois devrait être un des lieux clés de la
                  rencontre entre les présidents américains et russes. Retour
                  sur l’histoire singulière du cinq-étoiles.
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* <div className='ui container'>
        <video width='100%' height='auto' muted playsInline autoPlay loop>
          <source src={require('../../images/movie.mp4')} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </div> */}
      <Footer
        title='Comment évaluez-vous ce contenu?'
        questions={[
          'Était-il informatif?',
          'La mise en forme vous plaît-elle?',
          'Voudriez-vous voir davantage de ce type de contenu?'
        ]}
        mailTo='mathieu.rudaz@tamedia.ch'
        hidePortfolioTeaser
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          ['Textes', 'Julien Culet'],
          ['Photographies', 'Lucien Fortunati']
        ]}
      />
    </div>
  )
}
